import {useRef, useState, type ReactNode} from 'react';
import {Tooltip, TooltipContent, TooltipTrigger} from '@kroll-resolver-crisp/ui-components-react';
import {cn} from '@/lib/utils';

// One line of text clipped with an ellipsis. Its tooltip shows the full text, and only when the
// text is actually clipped - unlike a native `title=`, which also shows when nothing is cut off
// and cannot be reached from the keyboard.
export function TruncatedText({
  children,
  className
}: {
  readonly children: ReactNode;
  readonly className?: string;
}) {
  const ref = useRef<HTMLSpanElement>(null);
  const [open, setOpen] = useState(false);

  // Only offer the tooltip when the text is actually clipped.
  function handleOpenChange(next: boolean) {
    const el = ref.current;
    setOpen(next && el !== null && el.scrollWidth > el.clientWidth);
  }

  return (
    <Tooltip open={open} onOpenChange={handleOpenChange}>
      <TooltipTrigger render={<span ref={ref} className={cn('block truncate', className)} />}>
        {children}
      </TooltipTrigger>
      <TooltipContent side="bottom" align="start" className="max-w-xs text-left">
        <p className="break-words whitespace-pre-wrap">{children}</p>
      </TooltipContent>
    </Tooltip>
  );
}
